import { Container } from "@/features/common/components/Container";
import { SectionBanner } from "@/features/common/components/SectionBanner";
import { SiteLayout } from "@/features/layout/SiteLayout";
import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  project: { siteName, domain },
} = getPublicConfig();

const TermsOfServicePage = () => {
  return (
    <>
      <SectionBanner>服務條款</SectionBanner>
      <Container className="space-y-10 py-5 font-light text-gray-900 sm:py-10">
        <p>
          1. 簡介
          <br />
          歡迎使用 {siteName}！感謝您使用我們的網站{domain}和服務
          (以下簡稱「服務」)。「服務」是由「{siteName}」
          提供。只要您使用「服務」，即表示您同意本條款，故請詳讀本服務條款內容。
          {siteName}為您或您的關聯公司提供{domain}
          （「本平台」）。本平台允許商戶和KOL通過KOL的社交網絡或社交媒體（「平台服務」）進行互動和參與營銷關係，以創建和/或發佈贊助內容。但您必須接受並遵守服務條款（「服務條款」或「協議」）方可使用本平台。如果您不同意這些服務條款，請不要使用平台服務或
          {domain}
          。我們可以隨時通過修改本頁修改這些服務條款。請不時檢查此頁面，以留意我們作出的任何更改，因為它們對您具有約束力。除非您稍後與
          {siteName}
          就本平台或通告（如下文定義）達成任何其他協議，否則本協議構成您與
          {siteName}
          之間就您使用本平台為通告提交及發佈內容的完整協議。本協議取代了您與
          {siteName}
          之間任何就您使用本平台為通告提交及發佈內容的任何先前協議或提案，口頭或書面協議以及任何其他通信。在本服務條款中，（i）「商戶」是指直接代表商戶的代理人或由
          {siteName}
          授權代表商戶使用本平台服務的代理人，（ii）「KOL」是指通過本平台於其相關的社交網絡（即Youtube或Instagram等）創建和發佈贊助的社交內容的任何個人，實體或組織。（iv）「通告」是指商戶要求KOL通過其社交媒體帳戶創建和/或發佈贊助的社交內容和/或執行工作。這些服務條款適用於通過本平台進行的所有交易。
        </p>
        <p>
          1.1.通告和收費
          <br />
          KOL必須符合商戶於通告中指定的要求（以下簡稱「要求」）於其社交平台創建，發佈贊助社交內容或任何指定的動作以完成執行工作，方能取得薪酬
          。每個通告都應包含商戶指定的工作內容及商戶的預算支付薪酬，{siteName}
          也會從中徵收相應百分比的刊登費，商戶可以通過購買點數於{siteName}
          的帳戶並以點數支付刊登費（1點數 =
          HKD$1），購買點數可以通過信用卡、轉數快、銀行轉帳付款。KOL通過完善個人檔案申請通告，其中包括新增個人簡介、上傳KOL圖像，以及工作聯絡資料。申請可能會被商戶接受或婉拒。如果商戶要求在預計通告開始日期之前取消已接受了的申請或取消已刊登的通告，商戶在刊登通告時所支付的刊登費是不可退還的。
        </p>
        <p>
          1.2.審閱
          <br />
          {siteName}保留審閱和拒絕不符合我們平台指南的通告的權利。
        </p>
        <p>
          2. 資格
          <br />
          您必須年滿18歲才能在平台上註冊為商戶。未年滿18歲的KOL使用本平台均須經父母或監護人同意。通過註冊於本平台，您代表並保證您提交的所有資料是真實準確的，並且您同意保持此類資料的準確性。您理解並同意，
          {siteName}
          將根據此處所附的《隱私權政策》的條款使用您提供的資料，該《隱私權政策》將被納入於此服務條款的其中一部分。本平台中註冊的賬戶在任何情況下都不能轉移，轉讓或轉售。
        </p>
        <p>
          3. 商戶條款
          <br />
          本服務條款的第3段僅適用於參與本平台的商戶。3.1.透明度和披露任何試圖指示，強迫或操縱KOL隱藏商戶與KOL之間的商業關係可能會立即從系統中移除。3.2.商戶同意按照此服務條款支付
          {siteName}所有有關商戶帳戶的協議費用或使用平台服務的費用。3.3.{" "}
          {siteName}保留隨時修改，暫停或終止平台所需付款方式的權利。如果
          {siteName}
          修改付款方式的條款，該修改將反映於本協議的最新版本內。如果您不同意此類修改協議，您必須立即停止使用本平台。如果於任何修改後，品牌仍繼續使用，即表示品牌接受修改的條款和付款方式。3.4.手動處理要求商戶有責任審閱KOL的工作執行是否符合通告中規定的要求。如果商戶希望確保KOL的工作執行將被人手手動審查以符合項目要求，此類服務可能需要額外費用。商戶也可以要求
          {siteName}
          通過獨立的服務協議，管理部分或全部廣告活動。有興趣的人士應直接聯繫
          {siteName}
          。如有需要，商戶可能會要求KOL把已發佈的貼文從KOL的社交媒體網站或個人網站中刪除。
          {siteName}可以協助品牌請求KOL刪除有關內容，並可能收取額外費用; 然而，
          {siteName}不能保證KOL會刪除該內容。3.5.內容資料商戶同意，{siteName}
          對商戶的內容或產品概不負責。商戶完全承擔、負責任何要求，法律和法規，以及提供給KOL的任何材料及其有關許可。
          商戶知道並確認，KOL對{siteName}而言是獨立第三方，且不受{siteName}
          控制。KOL不是{siteName}的承包商或{siteName}
          的人員。因此，您知道您的內容或產品的任何發佈或贊助將會對您的內容，產品或公司產生負面的評論。商戶承認並同意，
          {siteName}
          無法控制任何可能在任何社交網絡（或其他）上發佈的內容，並且商戶將對KOL發佈的內容負全部責任（並承擔所有責任和風險）。就商戶提供或指定的任何內容和材料以執行本條款中規定的服務，商戶授權
          {siteName}
          及KOL可撤銷的，有限的及全球之許可。3.6.項目爭議商戶同意，只要KOL符合通告及第1節所述的要求，它不會延遲或拒絕支付薪酬。品牌不得根據KOL的種族，身體，政治，精神，年齡，性別或性取向特徵進行歧視。4.
          KOL條款第4節段僅適用於參與本平台的KOL。4.1.任何18歲以上的創作者均可在平台上註冊，未成年人士使用本平台均須經父母或監護人同意。未成年人士如需在本平台上註冊帳戶，他們及其父母需同意受本協議的條款約束。但是為了參與本平台，KOL的帳號應該符合以下最低標準：·
          社交網絡帳戶必須開始了至少90天;·
          社交網絡帳戶必須達到最少數量的關注者/粉絲的標準;·
          社交網絡帳戶不得包含超過90天的內容差距;· 社交網絡帳戶必須是公開的;·
          社交網絡帳戶必須包含大部分原創內容;·
          帳戶必須顯示指定的語言（英文，中文，或項目要求的）;·
          帳戶不能包含不適當，非法或違反本文第7節中詳細列明的“平台指南”的內容。4.2.達到通告要求並成功通過工作配對，KOL承認（i）它於規定時間內具備權限和能力執行該要求的工作（ii）所有提交的內容將使用英文或中文或其他語言（iii）所有提交的內容或行為將是原創，並不侵犯任何第三方的版權，專利，商標，商業秘密或其他知識產權，（iv）所有提交的內容或行動不包括或支持過度褻瀆，暴力，種族不容忍，非法藥物或吸毒用品，非法色情內容或任何其他促進不容忍，非法活動或侵犯他人合法權益的內容。KOL發佈的贊助內容（例如貼文）必須在項目指定的期限內在網絡上保持上線。4.3.
          KOL承認並同意補償KOL通告有關的廣告的義務歸於商戶，而不是{siteName}。
          {siteName}只是代表商戶促進這種補償。商戶完全負責支付給KOL 。
          在任何情況下，{siteName}不承擔向KOL付款的責任。KOL同意，它不會就
          {siteName}不付款的行為採取法律行動或其他方式
          。就商戶無法支付項目相關的賠償，KOL放棄與{siteName}
          有關的任何和所有索償或訴訟權利 。另外，KOL承認，KOL：（i）不是
          {siteName}
          的僱員，（ii）負責支付從商戶收到的補償衍生的所有稅項，（iii）負責當地政府的任何報告要求，以及（iv）負責遵守所有其他適用的法律法規。4.4.授權許可KOL保留通過其社交平台提交，發佈或顯示的任何內容的權利。您上傳到我們網站的任何內容將被視為非機密和非專有的。您保留所有內容的所有權，但是您必須向我們和本網站的其他用戶授予使用，存儲和複製該內容的有限許可，並將其分發並提供給第三方
          。KOL授予{siteName}及商戶 非獨享
          、全球性、永久、無需繳付版權費用、可自由轉讓及可再轉授的特許應用權，以共享，使用，複製，處理，調整，翻譯，顯示，執行，重新發佈和以任何和所有形式的媒體或分發方式
          分發內容或其任何部分，包括但不限於電視，廣播，打印， 和其他電子通信。
          {siteName}
          或任何其他商戶的任何使用，發佈或分發創作者的內容，可以但不一定需要引用KOL的姓名，肖像或其他識別表示方式
          。如果任何第三方聲稱您發佈或上傳到我們網站上的任何內容構成對其知識產權或隱私權的侵犯，我們有權向他們披露您的身份。我們將不對任何第三方負責就您或我們網站的任何其他用戶發佈的任何內容的內容或準確性。如果我們認為您的信息不符合我們條款和條件中規定的內容標準，我們有權刪除您在我們網站上發佈的任何信息。5.
          機密“機密資料”是指由{siteName}
          直接或間接以書面，口頭向商戶或KOL披露的任何資訊，除非該資料已經是公開的。商戶和/或KOL不得在任何時候（i）向任何個人或實體披露，出售，許可，轉讓或以其他方式提供任何機密資料（除了您的員工和代理人有合法需要了解此類信息）
          ，或（ii）使用，複製任何機密資料。
          商戶和/或KOL同意採取一切措施保護機密資料，避免披露和未經授權的使用。如果按法律要求披露機密資料，商戶和/或創作者需要通知
          {siteName}此類要求 。所有機密資料是{siteName}
          的個人資產，所有文件，電子媒體和其他有關任何機密資料的物品，應按
          {siteName}的要求在協議終止後立即發送給{siteName}。6.
          平台指南平台的所有參與者應遵守以下準則：· 色情內容不適用於本平台。·
          任何基於種族，族裔，宗教，殘疾，性別，年齡，退伍軍人身份或性取向/性別認同等群體的攻擊是不允許的。·
          不會有騷擾，威脅，侵犯隱私，掠奪性行為，纏擾或揭露其他成員的個人資料。·
          誤導性的說明，標題，縮略圖，標籤，大量的重複內容不符合本平台的規則。·
          除了付費項目之外，平台中的用戶不會招攬用戶。·
          不得有附加產品，徽標，第三方贊助商連結，廣告，照片上的重疊廣告位於贊助的帖子中
          。如果我們發現您未能遵守這些使用條款的任何規定，我們有權在任何時候禁止停止任何用戶使用本平台。7.
          未經授權使用在{siteName}
          提供的API之外，任何嘗試利用自動化程序，機器人，屏幕抓取，數據庫調用，人為啟動的數據收集或任何其他收集數據，內容或其他信息的方法，以逆向工程我們的平台獲得商業利益是嚴格禁止的。嚴格禁止任何操作平台中的類似數據，追隨者數目或任何其他相關數據或指標。任何此類未經授權的企圖將受到法律起訴。8.
          聲明及保證參與平台的KOL和商戶各自聲明，保證和約定，（i）您有足夠的權力簽訂協議;
          （ii）您使用{siteName}的服務僅用於合法的商業目的;
          （iii）任何內容中包含的連接都是針對目的而不是重新引導;
          （iv）您不會（並且不會允許或授權任何第三方）產生自動，欺詐或其他無效的行為，例如但不限於購買贊助內容的讚好，回應和分享;
          （iv）您將遵守香港的所有適用法律;
          （v）您有權提供本平台所提供的所有資料（包括所有內容，數據，聲明，產品和服務，項目，標題，網址和描述），以供本協議（「信息」）。參與平台的KOL及商戶各自聲明，保證和約定所有提交於本平台的資料不會：（a）違反任何法律，法規，條例，條約或法規或
          {siteName}的政策或準則;
          （b）侵犯任何第三方的版權，專利，商標，商業秘密，視頻，音樂表演或其他知識產權;
          （c）違反對任何個人或實體的任何義務或權利，包括宣傳或隱私權，並沒有導致或不可能導致任何消費者欺詐，產品責任，侵權，違約，損害或對任何個人或實體的任何形式的傷害;
          （d）宣傳任何非法產品或服務或非法銷售任何產品或服務。此外，您同意所有資料將（e）不是虛假的，欺騙的或具有誤導性的;
          （f）不得誹謗，中傷，淫穢或威脅;
          （g）不針對十三歲以下的兒童，（h）沒有病毒品牌進一步表示（i）它對廣告內的所有索賠具有合理的依據，並擁有適當的文件證明這些索賠;
          （ii）它將遵守適用的服務協議（如適用）;
          （iii）任何連接的著陸頁（即消費者點擊連接時需填寫註冊資料或採取類似操作的品牌網站頁面
          ）包含與品牌隱私政策的連接向消費者提供關於品牌使用，收集和披露其個人資料的充分通知，披露和選擇;
          （iv）它提供了KOL將為其提供或要求的任何內容提供所有必要的許可證和許可，並為KOL提供必要的法律和監管指導，以便KOL遵守所有適用的法律和法規要求。9.禰償KOL和品牌都同意全面及獨立地禰償及承擔
          {siteName}
          ，其母公司和關聯公司及其董事，許可人，合作夥伴，許可證持有者，顧問，承包商，代理人，律師，僱員，業主，第三方服務提供商和第三方因下列事由而肇生之任何第三方索賠、訟案、訴訟程序、審判、損害及費用
          (包括合理的律師費以及支出)，並對其進行賠償，為其抗辯並使其免受損害：實際上或據稱是由您的資料，使用服務，任何社交內容和/或行動，您的網站或您違反協議而導致的任何索償。10.免責聲明品牌和KOL明確同意，按現有資料提供服務，不附帶明示或暗示的任何形式的擔保，並且他們的使用是他們自己的風險。
          {siteName}
          在法律允許的最大範圍內免除任何明示或暗示的保證，包括但不限於（i）商銷性或針對特定用途的適合性的擔保，（ii）任何不會侵犯第三方知識產權或專有權的保證（iii）與服務或使用本平台或其任何部分相關的延遲，中斷，錯誤或疏忽相關的擔保，（iv）有關傳輸或傳送服務的保證，（v）與數據的準確性或正確性相關的擔保
          。此外，服務或本平台將不會對您的需求或要求或任何其他人士的需求或要求做出任何保證。另外，您確認並同意
          {siteName}
          的保證不包括由第三方引起的電話或互聯網失效或其他外部影響。服務可能由許多因素限制，包括互聯網的風險。11.責任限制與本協議有關
          {siteName}對商戶的任何責任，
          都限制於商戶就通告所支付的薪酬。對於由KOL使用服務造成的任何損害，
          {siteName}將不承擔任何責任。 在何情況下，{siteName}或{siteName}
          的任何人士均不承擔基於任何由本協議引起的或與本協議有關的任何間接，特殊，附帶，後果性，懲罰性或懲戒性損害的責任
          。商戶同意，{siteName}
          不需因任何第三方就協議的任何選擇或保留或任何行為，錯誤或遺漏負責，包括任何第三方點擊商戶的通告。我們不會因（i）用戶使用或無法使用我們的平台，或（ii）使用或依賴本平台上顯示的任何內容而衍生任何用戶因任何合約或侵權行為上的損失或損害（包括疏忽），違反法定責任或其他方面的任何損失或損害，即使在可預見的情況下而對該用戶承擔任何責任。我們不會就：（i）利潤，銷售，業務或收入損失;
          （ii）業務中斷; （iii）預期節省的損失;
          （iv）商戶與KOL之間訂立的任何交易; （五）失去商業機會，商譽或聲譽;
          或（vi）任何間接或後果性的損失或損害，承擔任何責任。12.法律管轄本協議受香港法律管轄。13.可分割性如果本協議提到的任何條款、約定或條件在任何程度上為或成為無效或不可執行，本協議的其它部分的效力不受影響，
          並在法律允許的最大限度內完全有效和可執行。14.其他商戶，KOL均屬本平台的獨立第三方，“協議”不得解釋為創建，證明或暗示本平台，KOL或商戶之間存在就業，合夥或合資的關係。商戶和KOL都不是
          {siteName}的員工。
        </p>
      </Container>
    </>
  );
};

export default TermsOfServicePage;

TermsOfServicePage.getLayout = function getLayout(page) {
  return <SiteLayout>{page}</SiteLayout>;
};
